'use strict';

import { BaseElement } from '../../interfaces/BaseElement';

export class DreamsPreloader {
	constructor (parent,additionalClass) {
		this.parent = parent;
		this.container = new BaseElement()
			.addClass('dreams-preloader','hidden')
			.appendTo(this.parent);
		
		if (additionalClass) {
			this.addClass(additionalClass);
		}
		
		const wrapper = new BaseElement()
			.addClass('dreams-preloader__wrapper')
			.appendTo(this.container.DOMElement)
			.DOMElement;
		
		new BaseElement()
			.addClass('dreams-preloader__loader')
			.appendTo(wrapper);
	}
	
	absolute() {
		this.addClass('dreams-preloader--absolute');
		return this;
	}
	
	blur() {
		this.addClass('dreams-preloader--blur');
		return this;
	}

	substrate() {
		this.addClass('dreams-preloader--substrate');
		return this;
	}
	
	scale(value) {
		this.container.addStyle('scale',value);
		return this;
	}
	
	show() {
		this.container.removeClass('hidden');
		return this;
	}
	
	remove() {
		this.container.remove();
	}
	
	hide() {
		this.container.addClass('hidden');
		return this;
	}
	
	addClass(name) {
		this.container.addClass(name);
		return this;
	}
	
	get element() {
		return this.container.DOMElement;
	}
}
